
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("l5Yc7", function(module, exports) {
/* RestrictionsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $2VQ4B = parcelRequire("2VQ4B");


var $9eE57 = parcelRequire("9eE57");


var $7zgzO = parcelRequire("7zgzO");


var $ckmNl = parcelRequire("ckmNl");


var $jLw6A = parcelRequire("jLw6A");


var $foQ4a = parcelRequire("foQ4a");


var $14SPd = parcelRequire("14SPd");


var $5nr5P = parcelRequire("5nr5P");


var $eE3dj = parcelRequire("eE3dj");


var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");





var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");

var $1cfRh = parcelRequire("1cfRh");


var $eEA8O = parcelRequire("eEA8O");


var $3gadb = parcelRequire("3gadb");


var $h1ewt = parcelRequire("h1ewt");


var $9Q2dU = parcelRequire("9Q2dU");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $6DT7W = parcelRequire("6DT7W");


var $boTVZ = parcelRequire("boTVZ");

const $c753b28d3ec82010$var$useRedirectedFromRestrictQueryParam = (0, $dPJCf.createSingleQueryParamHook)('redirectedFromRestrict');
const $c753b28d3ec82010$var$i18n = (0, $h82at.defineMessages)({
    noRestrictions: {
        id: "restrictions.button.no-restrictions.tooltip",
        defaultMessage: "No restrictions"
    },
    editRestrictionsApply: {
        id: "restrictions.button.edit-restrictions-apply.tooltip",
        defaultMessage: "Editing restricted"
    },
    restrictionsApply: {
        id: "restrictions.button.restrictions-apply.tooltip",
        defaultMessage: "Restrictions apply"
    },
    experimentRestrictions: {
        id: "restrictions.button.experiment-restrictions.tooltip",
        defaultMessage: "Upgrade to restrict content access"
    },
    restrictionsNotApplicableForSmartLinkEmbeds: {
        id: "restrictions.button.smart-link-embed-restrictions.tooltip",
        defaultMessage: "Additional restrictions can\u2019t be set for Smart Links"
    }
});
const $c753b28d3ec82010$var$getButtonContent = (isRestrictionButtonDisabled, defaulti18nMessage)=>{
    return isRestrictionButtonDisabled ? $c753b28d3ec82010$var$i18n.restrictionsNotApplicableForSmartLinkEmbeds : defaulti18nMessage;
};
const $c753b28d3ec82010$var$useGenerateButtonProps = (0, $3u0dr.isReactCompilerActiveV2)() ? (props, contentType)=>{
    const $ = (0, $frIzR.c)(4);
    const isRestrictionButtonDisabled = (0, $boTVZ.areRestrictionsDisabledForContentType)(contentType);
    const intl = (0, $1cfRh.default)();
    if (props.hasDirectViewRestrictions) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                spacing: "spacious",
                color: "var(--ds-icon-danger, #C9372C)",
                testId: "locked-icon",
                label: ""
            });
            $[0] = t0;
        } else t0 = $[0];
        return {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c753b28d3ec82010$var$getButtonContent(isRestrictionButtonDisabled, $c753b28d3ec82010$var$i18n.restrictionsApply)),
            icon: t0,
            ariaLabel: intl.formatMessage($c753b28d3ec82010$var$getButtonContent(isRestrictionButtonDisabled, $c753b28d3ec82010$var$i18n.restrictionsApply))
        };
    }
    if (props.hasInheritedViewRestrictions) {
        let t0;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h1ewt))), {
                color: "var(--ds-icon-danger, #C9372C)",
                testId: "unlocked-restricted-icon",
                label: ""
            });
            $[1] = t0;
        } else t0 = $[1];
        return {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c753b28d3ec82010$var$getButtonContent(isRestrictionButtonDisabled, $c753b28d3ec82010$var$i18n.restrictionsApply)),
            icon: t0,
            ariaLabel: intl.formatMessage($c753b28d3ec82010$var$getButtonContent(isRestrictionButtonDisabled, $c753b28d3ec82010$var$i18n.restrictionsApply))
        };
    }
    if (props.hasRestrictions && !props.hasDirectViewRestrictions) {
        let t0;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h1ewt))), {
                color: "var(--ds-icon, #292A2E)",
                testId: "unlocked-icon",
                label: ""
            });
            $[2] = t0;
        } else t0 = $[2];
        return {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c753b28d3ec82010$var$getButtonContent(isRestrictionButtonDisabled, $c753b28d3ec82010$var$i18n.editRestrictionsApply)),
            icon: t0,
            ariaLabel: intl.formatMessage($c753b28d3ec82010$var$getButtonContent(isRestrictionButtonDisabled, $c753b28d3ec82010$var$i18n.editRestrictionsApply))
        };
    }
    let t0;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h1ewt))), {
            testId: "unlocked-icon",
            label: ""
        });
        $[3] = t0;
    } else t0 = $[3];
    return {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c753b28d3ec82010$var$getButtonContent(isRestrictionButtonDisabled, $c753b28d3ec82010$var$i18n.noRestrictions)),
        icon: t0,
        ariaLabel: intl.formatMessage($c753b28d3ec82010$var$getButtonContent(isRestrictionButtonDisabled, $c753b28d3ec82010$var$i18n.noRestrictions))
    };
} : (props, contentType)=>{
    const isRestrictionButtonDisabled = (0, $boTVZ.areRestrictionsDisabledForContentType)(contentType);
    const intl = (0, $1cfRh.default)();
    if (props.hasDirectViewRestrictions) // locked
    return {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c753b28d3ec82010$var$getButtonContent(isRestrictionButtonDisabled, $c753b28d3ec82010$var$i18n.restrictionsApply)),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
            spacing: "spacious",
            color: "var(--ds-icon-danger, #C9372C)",
            testId: "locked-icon",
            label: ""
        }),
        ariaLabel: intl.formatMessage($c753b28d3ec82010$var$getButtonContent(isRestrictionButtonDisabled, $c753b28d3ec82010$var$i18n.restrictionsApply))
    };
    if (props.hasInheritedViewRestrictions) // unlocked restricted
    return {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c753b28d3ec82010$var$getButtonContent(isRestrictionButtonDisabled, $c753b28d3ec82010$var$i18n.restrictionsApply)),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h1ewt))), {
            color: "var(--ds-icon-danger, #C9372C)",
            testId: "unlocked-restricted-icon",
            label: ""
        }),
        ariaLabel: intl.formatMessage($c753b28d3ec82010$var$getButtonContent(isRestrictionButtonDisabled, $c753b28d3ec82010$var$i18n.restrictionsApply))
    };
    // note: the " && !hasDirectViewRestrictions" is excessive, as the have a check above,
    // but it's just easier to read this way.
    if (props.hasRestrictions && !props.hasDirectViewRestrictions) return {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c753b28d3ec82010$var$getButtonContent(isRestrictionButtonDisabled, $c753b28d3ec82010$var$i18n.editRestrictionsApply)),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h1ewt))), {
            color: "var(--ds-icon, #292A2E)",
            testId: "unlocked-icon",
            label: ""
        }),
        ariaLabel: intl.formatMessage($c753b28d3ec82010$var$getButtonContent(isRestrictionButtonDisabled, $c753b28d3ec82010$var$i18n.editRestrictionsApply))
    };
    // unlocked
    return {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $c753b28d3ec82010$var$getButtonContent(isRestrictionButtonDisabled, $c753b28d3ec82010$var$i18n.noRestrictions)),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h1ewt))), {
            testId: "unlocked-icon",
            label: ""
        }),
        ariaLabel: intl.formatMessage($c753b28d3ec82010$var$getButtonContent(isRestrictionButtonDisabled, $c753b28d3ec82010$var$i18n.noRestrictions))
    };
};
const $c753b28d3ec82010$export$79f22d97fd34c0f6 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(15);
    const [contentType] = (0, $ep3mz.useContentType)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const isRedirectedFromRestrict = $c753b28d3ec82010$var$useRedirectedFromRestrictQueryParam();
    const { content: content, icon: icon, ariaLabel: ariaLabel } = $c753b28d3ec82010$var$useGenerateButtonProps(props, contentType);
    let t0;
    if ($[0] !== props) {
        t0 = (...t1)=>{
            const args = t1;
            props.onClick?.(...args);
        };
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const handleOnClick = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            width: "32px"
        };
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== ariaLabel || $[4] !== handleOnClick || $[5] !== icon || $[6] !== props.isDisabled) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle",
            "data-test-id": "restrictions.dialog.button",
            onClick: handleOnClick,
            isDisabled: props.isDisabled,
            iconBefore: icon,
            "aria-label": ariaLabel,
            "data-id": "restrictions-button",
            style: t1
        });
        $[3] = ariaLabel;
        $[4] = handleOnClick;
        $[5] = icon;
        $[6] = props.isDisabled;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== contentId || $[9] !== isRedirectedFromRestrict) {
        t3 = contentId && isRedirectedFromRestrict ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6DT7W.RequestAccessPopupComponent), {
            contentId: contentId
        }) : null;
        $[8] = contentId;
        $[9] = isRedirectedFromRestrict;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== content || $[12] !== t2 || $[13] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: content
        }, t2, t3);
        $[11] = content;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
    } else t4 = $[14];
    return t4;
} : (props)=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const isRedirectedFromRestrict = $c753b28d3ec82010$var$useRedirectedFromRestrictQueryParam();
    const { content: content, icon: icon, ariaLabel: ariaLabel } = $c753b28d3ec82010$var$useGenerateButtonProps(props, contentType);
    const handleOnClick = (...args)=>{
        props.onClick?.(...args);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        "data-test-id": "restrictions.dialog.button",
        onClick: handleOnClick,
        isDisabled: props.isDisabled,
        iconBefore: icon,
        "aria-label": ariaLabel,
        "data-id": "restrictions-button",
        style: // The button's icon's svg isn't in itself forcing a
        // minimum button width, so if we don't manually apply one,
        // it'll get condensed when squeezed (for example by the
        // big web item you'll to its left see on our integration
        // test servers)
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        {
            width: '32px'
        }
    }), contentId && isRedirectedFromRestrict ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6DT7W.RequestAccessPopupComponent), {
        contentId: contentId
    }) : null);
};


const $764e18c7c0d05103$var$restrictionButtonContainerStyle = null;
const $764e18c7c0d05103$var$hiddenStyles = null;
const $764e18c7c0d05103$export$4d8f74e77ff853b8 = (props)=>{
    const { className: className, onClick: onClick, isDisabled: isDisabled, resetDialogState: resetDialogState, restrictionsButtonSSRRendered: restrictionsButtonSSRRendered = false, restrictionsButtonSSRLocation: restrictionsButtonSSRLocation = '', triggeredFrom: triggeredFrom = '' } = props;
    const contentId = (0, $ckmNl.useContentId)(props.contentId);
    const { isExternalCollaborator: isGuest } = (0, $foQ4a.useIsExternalCollaborator)();
    const isRestrictionsButtonSSRRendered = Boolean(window.__SSR_RENDERED__ && restrictionsButtonSSRRendered);
    const restrictionsButtonClicked = (0, $42omo.useCallback)((restrictionsDataContainer, hasRestrictions, hasInheritedRestrictions, hasDirectViewRestrictions)=>{
        restrictionsDataContainer.setData({
            hasRestrictions: hasRestrictions,
            hasInheritedRestrictions: hasInheritedRestrictions,
            hasDirectViewRestrictions: hasDirectViewRestrictions
        });
        onClick();
    }, [
        onClick
    ]);
    const { transitionId: transitionId } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    (0, $42omo.useEffect)(()=>{
        if (resetDialogState && transitionId) resetDialogState();
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        transitionId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isRestrictionsButtonSSRRendered) //set FMP now if SSR rendered for default restrictions dialog
        (0, $14SPd.RESTRICTIONS_BUTTON_METRIC).markFMP((0, $9eE57.getMark)('CFP-63.ssr-ttr'));
    }, [
        isRestrictionsButtonSSRRendered
    ]);
    const restrictionButtonGenerator = (0, $42omo.useCallback)((restrictionsDataContainer, hasDirectViewRestrictions, hasInheritedViewRestrictions, hasRestrictions)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: (0, $gMc0m.default)([
                "_13bofhey",
                className || ''
            ]),
            "data-testid": "restriction-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c753b28d3ec82010$export$79f22d97fd34c0f6), {
            hasDirectViewRestrictions: hasDirectViewRestrictions,
            hasInheritedViewRestrictions: hasInheritedViewRestrictions,
            hasRestrictions: hasRestrictions,
            onClick: ()=>restrictionsButtonClicked(restrictionsDataContainer, hasDirectViewRestrictions, hasInheritedViewRestrictions, hasRestrictions),
            isDisabled: isDisabled
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
            key: `end-${contentId}`,
            metric: (0, $14SPd.RESTRICTIONS_BUTTON_METRIC),
            customData: {
                restrictionsButtonSSRRendered: restrictionsButtonSSRRendered,
                restrictionsButtonSSRLocation: restrictionsButtonSSRLocation,
                triggeredFrom: triggeredFrom
            }
        }));
    }, [
        className,
        restrictionsButtonClicked,
        isDisabled,
        contentId,
        restrictionsButtonSSRRendered,
        restrictionsButtonSSRLocation,
        triggeredFrom
    ]);
    const { restrictions: restrictions, loading: loading } = (0, $jLw6A.usePageRestrictionsContext)();
    const isQueryLoading = !restrictions && loading;
    if (!contentId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $5nr5P.RestrictionsDataContainer)
        ]
    }, (restrictionsDataContainer)=>{
        if (isQueryLoading || isGuest) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-test-id": "restriction-placeholder-container",
            className: (0, $gMc0m.default)([
                isGuest && "_1e0cglyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null));
        const hasDirectViewRestrictions = Boolean(restrictions?.hasViewRestrictions);
        const hasInheritedRestrictions = Boolean(restrictions?.hasInheritedRestrictions);
        const hasRestrictions = Boolean(restrictions?.hasRestrictions);
        return restrictionButtonGenerator(restrictionsDataContainer, hasDirectViewRestrictions, hasInheritedRestrictions, hasRestrictions);
    });
};
module.exports["RestrictionsButton"] = $764e18c7c0d05103$export$4d8f74e77ff853b8;

});

parcelRegister("14SPd", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

var $jIOyV = parcelRequire("jIOyV");

const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
const $8ab24ab9418ac89d$export$2ba38536ff91e2a7 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.RESTRICTIONS_DIALOG_INTERACTION)
});
module.exports["RESTRICTIONS_BUTTON_METRIC"] = $8ab24ab9418ac89d$export$34cc51d2a4e5cf67;
module.exports["RESTRICTIONS_DIALOG_METRIC"] = $8ab24ab9418ac89d$export$2ba38536ff91e2a7;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("boTVZ", function(module, exports) {
function $931d0cc8e8f4f258$export$a7e172d99bfa7de7(contentType) {
    if (contentType === 'embed') return true;
    return false;
}
module.exports["areRestrictionsDisabledForContentType"] = $931d0cc8e8f4f258$export$a7e172d99bfa7de7;

});


//# sourceMappingURL=RestrictionsButton.9df573c2.js.map
